import React from 'react';
import { Box } from 'grommet';
import Header from 'components/common/Header';
import Footer from 'components/common/Footer';
import Drawer from 'components/common/Drawer';

class PublicLayout extends React.Component {
  render() {
    return (
      <Box
        background="light-1"
        border={{ color: 'brand', size: 'xlarge' }}
        direction="column"
      >
        <Box
          background="transparent"
          margin={{ right: 'small', top: 'small' }}
          height="60px"
        >
          <Header />
        </Box>
        <Drawer />
        <Box background="light-1" flex={true}>
          {this.props.children}
        </Box>
        <Box background="transparent">
          <Footer />
        </Box>
      </Box>
    );
  }
}

export default PublicLayout